import styled from '@emotion/styled/macro';
import vars from '@variables';
import {
  ExploreLinkProps,
  IconWrapperProps,
  NavFullWidthContainerProps,
} from './navbar-block.types';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';
import { shouldForwardProp } from '@utils/utils';

export const StyledNav = styled(motion.nav)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
`;

export const NavFullWidthContainer: React.FC<NavFullWidthContainerProps> =
  styled(motion.div, {
    shouldForwardProp: prop =>
      shouldForwardProp(
        ['hideBorders', 'mobileMenuOpen', 'backgroundColor'],
        prop
      ),
  })(({ hideBorders, mobileMenuOpen, backgroundColor }) => {
    return `
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid lightGrey;
  position: relative;
  z-index: 8;  
  background-color: ${backgroundColor || vars.white};
  ${
    hideBorders &&
    `
    box-shadow: none;
    border-bottom: 0;
    `
  }
  ${
    mobileMenuOpen &&
    `
    background-color: ${vars.white};
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid lightGrey;
  `
  }
  `;
  });
export const NavContentContainer = styled.div`
  padding-left: ${vars.spacingM};
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: ${vars.mainMaxWidth};
  margin: 0 auto;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    padding: 0 ${vars.spacingL};
  }
`;

export const TabletAndDesktopWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    display: flex;
    align-items: center;
  }
`;

export const MobileNavWrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    display: none;
  }
`;

export const ExploreLink = styled(Link, {
  shouldForwardProp: prop => shouldForwardProp(['hideBorders'], prop),
})<ExploreLinkProps>(({ hideBorders }) => {
  return `
  display: block;
  height: 58px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 0;
  border-right: 0;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    border-left: ${hideBorders ? '0px' : '1px solid lightGrey'};
    border-right: ${hideBorders ? '0px' : '1px solid lightGrey'};
    height: ${vars.primaryNavHeight};
    width: ${vars.primaryNavHeight};

    :hover {
      background-color: ${vars.coreDarkGrey};
      border-left: 1px solid ${vars.coreDarkGrey};
      border-right: 1px solid ${vars.coreDarkGrey};

      svg path {
        fill: white;
      }
    }
  }
`;
});

export const IconWrapper = styled.div<IconWrapperProps>`
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isOpen }) =>
    isOpen &&
    `
    background-color: ${vars.coreDarkGrey};

    svg path {
      fill: white;
    }

  `}
`;
